import React, { Component } from 'react'
import { connect } from 'react-redux'
import { injectIntl, intlShape } from 'react-intl'
import Helmet from 'react-helmet';

import Loader from '../components/Loader'

import FullbleedHero from '../components/ContentBlocks/FullbleedHero'
import ContentBlockImage from '../components/ContentBlocks/ContentBlockImage'
import ContentBlockHolder from '../components/ContentBlocks/ContentBlockHolder'
import ContentBlock from '../components/ContentBlocks/ContentBlock'
import FullbleedContentBlock from '../components/ContentBlocks/FullbleedContentBlock'

import { fetchPage, fetchCollection, fetchReservationTexts } from '../redux/actions'

import get from 'lodash/get';

import ReservationPage from './ContentPages/ReservationPage'
import OfferForm from '../components/OfferForm'
import ShopifyProduct from '../components/Shopify/ShopifyProduct'

class ContentPage extends Component {
  componentDidMount() {
    this.checkForPageData();
  }

  componentDidUpdate() {
    this.checkForPageData();
  }

  checkForPageData() {
    const locale = this.props.intl.locale;
    const slug = this.props.match.params.slug;
    const page = this.props.pages[slug];
    const collection = this.props.collection;

    if (!page) {
      this.props.fetchPage(slug, locale)
    }

    if(page) {
      if(page.slug === 'reservation') {
        if (!this.props.reservationTexts) {
          this.props.fetchReservationTexts(this.props.intl.locale);
        }
      }
      if(page.elements) {
        if (!collection && page.elements.filter(e => e.sys.contentType.sys.id==='shopifyCollection').length > 0) {
          const collectionId = page.elements.find((e) => {
            return e.sys.contentType.sys.id==='shopifyCollection'
          }).fields.collectionId;

          this.props.fetchCollection(collectionId);
        }
      }
    }
  }

  render() {
    const slug = this.props.match.params.slug
    const {pages} = {...this.props}

    const page = pages[slug]

    const collection = this.props.collection

    return (
      <div>
        {!pages[slug] && <Loader/>}
        {pages[slug] &&
          <div className={page.slug} style={page.slug==='reservation'?{backgroundImage: `url(${get(this.props, 'reservationTexts.backgroundImage.fields.file.url')}`}:null}>
            <Helmet>
              <title>{page.title}</title>
            </Helmet>

            {page.elements &&
              page.elements.map((key, i) => {
                if (key.sys.contentType.sys.id==='header') {
                  return (
                    <FullbleedHero key={key.sys.id} fields={key.fields} slug={slug} />
                  )
                }

                if(key.sys.contentType.sys.id==='container') {
                  if(key.fields.type===true) {
                    const align = key.fields.align.toLowerCase()

                    if((align==='left'||align==='right') && key.fields.image) {
                      return (
                        <ContentBlockImage align={align} fields={key.fields} key={key.sys.id} />
                      )
                    }

                    if(align==='dual') {
                      return (
                        <ContentBlockHolder dual key={key.sys.id}>
                          {key.fields.elements.map((key, i) => {
                            return (
                              <ContentBlock key={key.sys.id} align={key.fields.align.toLowerCase()} fields={key.fields} />
                            )
                          })}
                        </ContentBlockHolder>
                      )
                    }

                    return (
                      <ContentBlockHolder key={key.sys.id}>
                        <ContentBlock align={align} fields={key.fields} />
                      </ContentBlockHolder>
                    )
                  }
                  if(key.fields.type===false) {
                    return (
                      <FullbleedContentBlock key={key.sys.id} align={key.fields.align.toLowerCase()} fields={key.fields} />
                    )
                  }
                }
                if (key.sys.contentType.sys.id==='shopifyCollection') {
                  return (
                    <div key={key.sys.id} className="shopify-container">
                      {collection && collection.map((key, i) => {
                        return (
                          <ShopifyProduct key={key.id} product={key} {...this.props} />
                        )
                      })}
                    </div>
                  )
                }
                return null;
              })
            }

            {page.slug === 'reservation' &&
              <ReservationPage elements={page.elements} />
            }
            {page.slug === 'premium-catering' &&
              <OfferForm />
            }
          </div>
        }
      </div>
    );
  }
}

ContentPage.propTypes = {
  intl: intlShape.isRequired,
}

const mapStateToProps = state => ({
  pages: state.pages,
  collection: state.collections,
  reservationTexts: state.reservationTexts
})

const mapDispatchToProps = {
  fetchPage,
  fetchCollection,
  fetchReservationTexts
}

export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(ContentPage))



// WEBPACK FOOTER //
// ./src/containers/ContentPage.js